import {createViewerScript} from '@wix/wixstores-client-core/dist/es/src/viewer-script/createViewerScript';

export const controllersConfig = createViewerScript(null, {useWorkerRaven: true});
